import { observer } from 'mobx-react';
import { ORDER_DINE_IN_TYPE } from 'src/constants/order';
import { formatDate, getTranslate } from 'src/utils/helpers';
import OrderBlockHeader from 'src/view/screens/OrderScreen/components/OrderBlockHeader/OrderBlockHeader';
import OrderBlockItem from 'src/view/screens/OrderScreen/components/OrderBlockItem/OrderBlockItem';
import { useOrderStoreContext } from '~/view/screens/OrderScreen/context';
import './style.scss';

interface IItem {
  title: string;
  data: string | number | undefined;
  unsection?: boolean;
}

const Item = (item: IItem) => {
  return (
    <OrderBlockItem
      title={item.title}
      titleClassName={`${item.unsection ? 'dine-in-customer__item-title_unsection' : 'dine-in-customer__item-title'}`}
      data={item.data}
    />
  );
};

const DineInCustomerInfo = observer(() => {
  const { store: orderStore } = useOrderStoreContext();
  if (!orderStore.order) return null;

  return (
    <ul className="dine-in-customer d-flex flex-column">
      <div className="dine-in-customer__container p-2">
        <OrderBlockHeader title="Customer" />
        {orderStore.order.dinein?.dinein_delivery_type === ORDER_DINE_IN_TYPE.DINE_IN ? (
          <>
            <Item title="section" data={getTranslate(orderStore.order.dinein.section?.name)} />
            <Item title="txt_table" data={getTranslate(orderStore.order.dinein.table?.name)} />
          </>
        ) : null}
        <Item title="hint_name" data={orderStore.order.customer_first_name} />
        <Item title="txt_mobile" data={orderStore.order.customer_mobile} />
      </div>
      {orderStore.order.customer_email ? <Item title="hint_email_id" data={orderStore.order.customer_email} unsection /> : null}
      <Item title="Order Creation Time" data={formatDate(orderStore.order.created_at, {})} unsection />
    </ul>
  );
});

export default DineInCustomerInfo;
